import createFormStore from '@common/stores/createFormStore';

const formStore = createFormStore({
  endpoint: '/api/v3/referrals/apply-coupon/',
  fields: {
    coupon_code: '',
  },
  name: 'referral.applyCoupon',
});

export const { actionTypes } = formStore;

export const { actions } = formStore;

const { reducer } = formStore;

export default reducer;
